import { type Member } from '@/features/iam/members/Member'
import { type OpportunitiesSearchViewModel } from './OpportunitiesSearchViewModel'
import { type Observable } from 'rxjs'
import { filter, map, skip, tap } from 'rxjs/operators'

/**
 * Syncs the workspace filter of the opportunities searcher when the current
 * member changes.
 */
export function syncWorkspaceFilter(
  searcher: OpportunitiesSearchViewModel,
  currentMember$: Observable<Member>,
) {
  return currentMember$.pipe(
    // Skip the first time we get a value here because we want to show "All Jobs/Opportunities" first
    skip(1),
    // Only switch if we were already filtering by a Workspace.
    filter(() => searcher.workspaceFilter.type === 'SpecificWorkspace'),
    map((x) => x.workspace),
    tap(searcher.selectWorkspaceForFiltering),
  )
}
